module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_02 (2).6a87ccce.png";